import { useCallback, useEffect, useMemo, useState } from 'react';

import { ThemeContext } from '@/shared/context/ThemeContext';

const getInitialTheme = () => localStorage.getItem('theme') || 'light';

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(getInitialTheme);

  const applyTheme = useCallback((preference) => {
    const isDark =
      preference === 'dark' ||
      (preference === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
    document.documentElement.dataset.theme = isDark ? 'dark' : 'light';
  }, []);

  useEffect(() => {
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = () => applyTheme(theme);
    applyTheme(theme);
    media.addEventListener('change', handleChange);
    return () => media.removeEventListener('change', handleChange);
  }, [applyTheme, theme]);

  const setTheme = useCallback(
    (preference) => {
      localStorage.setItem('theme', preference);
      setThemeState(preference);
      applyTheme(preference);
    },
    [applyTheme],
  );

  const value = useMemo(() => ({ theme, setTheme }), [setTheme, theme]);
  return <ThemeContext value={value}>{children}</ThemeContext>;
}
